module.exports = __webpack_public_path__ + "a7c2213765db5e90d33cc5b6e6507cc9.png";